import React from "react";
import Carousel from "react-spring-3d-carousel";
import { config } from "react-spring";
import greenDrop from "../../img/green_drop.svg";
import greenEnergy from "../../img/green_energy.svg";
import co2Colored from "../../img/co2Colored.png";
import green_chimicals from "../../img/green_chimicals.svg";
import "./Carousel3D.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

export default class Carousel3D extends React.Component<Props> {
  state = {
    goToSlide: 0,
    offsetRadius: 2,
    showNavigation: false,
    config: config.gentle,
    hovered: false,
  };

  componentDidMount() {
    // @ts-ignore
    this.timer = setInterval(() => {
      if (!this.state.hovered) {
        this.setState({
          goToSlide: this.state.goToSlide === 3 ? 0 : this.state.goToSlide + 1,
        });
      }
    }, 4000);
  }
  componentWillUnmount() {
    // @ts-ignore
    clearInterval(this.timer);
  }

  content1 = (
    <div className="carousel_item">
      <img src={greenDrop} alt="100% waste water treated" />
      <p>
        100% waste water treated of which 80% recycled 93% real water
        consumption reduction over the past 10 years
      </p>
    </div>
  );
  content2 = (
    <div className="carousel_item">
      <img src={greenEnergy} alt="Green energy" />
      <p>25% green energy in 2020 100% green energy by 2025</p>
    </div>
  );
  content3 = (
    <div className="carousel_item">
      <img src={co2Colored} alt="CO2 neural" />
      <p>CO2 neutral since 2017</p>
    </div>
  );
  content4 = (
    <div className="carousel_item">
      <img src={green_chimicals} alt="CO2 neural" />
      <p>50% less chemicals products since 10 years</p>
    </div>
  );

  slides = [
    {
      key: Math.floor(Math.random() * 1000),
      content: this.content1,
    },
    {
      key: Math.floor(Math.random() * 1000),
      content: this.content2,
    },
    {
      key: Math.floor(Math.random() * 1000),
      content: this.content3,
    },
    {
      key: Math.floor(Math.random() * 1000),
      content: this.content4,
    },
  ].map((slide, index) => {
    return { ...slide, onClick: () => this.setState({ goToSlide: index }) };
  });

  onChangeInput = (e: any) => {
    this.setState({
      [e.target.name]: parseInt(e.target.value, 10) || 0,
    });
  };

  render() {
    return (
      <div className="sustainabiliy">
        <div className="blue_line"></div>
        <h1 className="h2_subtitle text-center">
          OUR COMMITMENT TO SUSTAINABILITY
        </h1>
        <p className="sustainability_paragraph">
          We have a long track record in sustainability and are proud of our
          accomplishments. We recognize our responsibility to help ensure the
          long-term health of the earth, now and for future generations.
        </p>
        <p className="sustainability_paragraph">
          We incorporate sustainability into every process of our business and
          we take several measures to reduce our consumption of water, energy
          and chemicals, to avoid waste and to fight climate change.
        </p>
        <div
          className="carousel3D_wrapper"
          onMouseOver={() => this.setState({ hovered: true })}
          onMouseLeave={() => this.setState({ hovered: false })}
        >
          <Carousel
            slides={this.slides}
            goToSlide={this.state.goToSlide}
            offsetRadius={this.state.offsetRadius}
            showNavigation={this.state.showNavigation}
            animationConfig={this.state.config}
          />
        </div>
        {this.props.width <= 1780 && (
          <div className="d-flex justify-content-center align-items-center">
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="mx-4"
              style={{ opacity: 0.5 }}
              onClick={() =>
                this.setState({ goToSlide: this.state.goToSlide - 1 })
              }
            />
            <FontAwesomeIcon
              icon={faArrowRight}
              className="mx-4"
              style={{ opacity: 0.5 }}
              onClick={() =>
                this.setState({ goToSlide: this.state.goToSlide + 1 })
              }
            />
          </div>
        )}
      </div>
    );
  }
}

interface Props {
  width: number;
}
